<p>profile-dialog works!</p>
